'use client';

import { createContext, useState, ReactNode } from 'react';

// Define the types for our context state and functions
interface LayoutConfigContextValue {
    hasHobe: boolean;
    hasNavbar: boolean;
    setLayoutConfig: (config: { showHobe?: boolean; showNavbar?: boolean }) => void;
}

export interface LayoutConfig {
    showHobe?: boolean;
    showNavbar?: boolean;
}

// Define the initial context value as null
export const LayoutConfigContext = createContext<LayoutConfigContextValue | null>(null);

// Define the props for the provider component
interface LayoutConfigProviderProps {
    children: ReactNode;
}

const LayoutConfigProvider: React.FC<LayoutConfigProviderProps> = ({ children }) => {
    const [hasHobe, setHasHobe] = useState<boolean>(true);
    const [hasNavbar, setHasNavbar] = useState<boolean>(true);

    const setLayoutConfig = ({ showHobe, showNavbar }: LayoutConfig) => {
        setHasHobe(showHobe ?? hasHobe);
        setHasNavbar(showNavbar ?? hasNavbar);
    };

    return (
        <LayoutConfigContext.Provider value={{ hasHobe, hasNavbar, setLayoutConfig }}>
            {children}
        </LayoutConfigContext.Provider>
    );
};

export default LayoutConfigProvider;
